import { ActionTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { RootState } from '@/store/state';
import { userApiService } from '@/api';
import { UserState } from '@/store/modules/user/state';
import { AuthModel } from '@/models/UserModel';

const actions: ActionTree<UserState, RootState> = {

  async [ActionTypes.GuestSignIn]({ commit }) {
    const auth: AuthModel = await userApiService.guestSignIn();
    return commit(ActionTypes.GuestSignIn, auth);
  },

};

export default actions;
